module.exports = __webpack_public_path__ + "static/imageBootcamp-f696424986e90bddcf5c03ef9410b1d3.png";